// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-card[data-v-036ef0b8]{background:var(--q4s-paper-sheet);background-color:var(--q4s-surface-card);border:var(--q4s-card-border);border-radius:var(--q4s-card-radius);box-shadow:var(--q4s-shadow-1);padding:18px 18px 0}", ""]);
// Exports
module.exports = exports;
